import React, { useState } from "react";
import Dialog from "../../../../shared/dialog";
import MyButton from "./../../../../shared/buttons/primary";

const DeleteDialog = (props) => {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  async function deleteMenu() {
    setIsBtnDisabled(true);
    window
      .axios({
        url: `menu/${props.data.id}/`,
        method: "delete",
      })
      .then(() => {
        onCloseRequest(props.data);
      });
  }

  function onCloseRequest(data) {
    props.onCloseRequest(data);
  }

  return (
    <Dialog
      id="menu-delete-dialog"
      className={"staff-delete-dialog"}
      title={"削除"}
      isShow={props.isShow}
      onCloseRequest={() => onCloseRequest({})}
      closeOnOverlayClick={true}
    >
      <div>
        <h2 className="text-center">削除でよろしいですか？</h2>
        <div className="booking-form__btns">
          <MyButton
            className="me-1"
            myVariant="cancel"
            disabled={isBtnDisabled}
            onClick={() => onCloseRequest({})}
          >
            キャンセル
          </MyButton>
          {/* <span
            type="button"
            className="cancel-button me-1"
            onClick={() => onCloseRequest({})}
          >
            キャンセル
          </span> */}
          <MyButton
            myVariant="delete"
            isLoading={isBtnDisabled}
            onClick={deleteMenu}
          >
            削除
          </MyButton>
          {/* <span type="button" className="delete-button" onClick={deleteMenu}>
            削除
          </span> */}
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
